// ***SITE CREDIT***

console.log(
  '%cSite by View Source \n%cview-source.com',
  ['margin: 20px 0 0;', 'font-size: 12px', 'font-family: Helvetica, sans-serif', 'font-weight: 700'].join(';'),
  ['margin: -5px 0 20px;', 'font-size: 12px', 'font-family: Helvetica, sans-serif', 'font-weight: 400'].join(';')
)

// ***GLOBAL VARIABLES***

const root = document.documentElement
let scrollHandler = null

// enable the possibility for browser-specific CSS
root.setAttribute('data-useragent', navigator.userAgent)

const vs = {
  tabletBreakpoint: 1024,
  mobileBreakpoint: 600,
  isTouchDevice: window.matchMedia('(any-hover: none)').matches,
}

vs.isTabletUp = innerWidth > vs.tabletBreakpoint
vs.isTabletDown = innerWidth <= vs.tabletBreakpoint
vs.isMobileUp = innerWidth > vs.mobileBreakpoint
vs.isMobileDown = innerWidth <= vs.mobileBreakpoint
vs.hasLocalStorage = () => {
  try {
    var storage = window['localStorage'],
      x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch (e) {
    return false
  }
}
vs.browserType = () => {
  const ua = navigator.userAgent

  if ((ua.indexOf('Opera') || ua.indexOf('OPR')) != -1) {
    return 'Opera'
  } else if (ua.indexOf('Chrome') != -1) {
    return 'Chrome'
  } else if (ua.indexOf('Safari') != -1) {
    return 'Safari'
  } else if (ua.indexOf('Firefox') != -1) {
    return 'Firefox'
  } else if (ua.indexOf('MSIE') != -1 || !!document.documentMode === true) {
    return 'IE'
  } else {
    return 'Unknown'
  }
}

window.addEventListener('resize', () => {
  vs.isTabletUp = innerWidth >= vs.tabletBreakpoint
  vs.isTabletDown = innerWidth < vs.tabletBreakpoint
  vs.isMobileUp = innerWidth >= vs.mobileBreakpoint
  vs.isMobileDown = innerWidth < vs.mobileBreakpoint
})

// ***BFCACHE*** https://web.dev/bfcache

// prevent safari to load from cache
window.addEventListener('pageshow', (event) => {
  if (event.persisted) location.reload(true)
})

// prevent chrome to load from cache
const perfEntries = performance.getEntriesByType('navigation')
if (typeof perfEntries[0] != 'undefined') {
  if (perfEntries[0].type === 'back_forward') location.reload(true)
}

// ***UTILITIES / GET***

const getRandomInt = (min, max) => {
  const _min = Math.ceil(min)
  const _max = Math.floor(max)

  // inclusive of max and min
  return Math.floor(Math.random() * (_max - _min + 1) + _min)
}

const getSiblings = (el) => {
  return Array.from(el.parentNode.children).filter(function (sibling) {
    return sibling !== el
  })
}

// ***UTILITIES / FORMAT***

const formatHandleize = (string) => {
  return String(string)
    .normalize('NFKD') // split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/[^\w-]/g, '') // remove non-alphanumeric characters except hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
}

const formatPad = (val, length = 2, char = 0) => {
  // example, leading zero: 8 = "08",
  // example, password: 000088885581 = "********5581"
  return val.toString().padStart(length, char)
}

const formatNumberCommas = (string) => {
  // example, formatNumberWithCommas(3000.12) = 3,000.12
  const parts = string.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return parts.join('.')
}

const formatNumberEuro = (string) => {
  // example, formatNumberEuro(3000.12) = 3 000,12
  const parts = string.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

  return parts.join(',')
}

// ***UTILITIES / VALIDATION***

const validateJson = (string) => {
  try {
    JSON.parse(string)
  } catch (e) {
    console.error(e)
    return false
  }

  return JSON.parse(string)
}

// ***UTILITIES / ARRAY***

/*
 * Concept: Prevents background scrolling while allowing specific elements to scroll
 *
 * Usage:
 *  const scrollHandler = new ScrollHandler();
 *  scrollHandler.scrollDisable(); // Lock background (body), allow .js-scroll-lock elements to scroll
 *  scrollHandler.scrollEnable(); // Restore normal scrolling
 */
class ScrollHandler {
  constructor(containerElQuery = 'body') {
    this.containerElQuery = containerElQuery
    this.cleanupScrollTrap = null
    this.observer = null

    // Stores the Y position of the last touch event
    this.lastTouchY = null

    // Store bound listeners for proper cleanup
    this.boundHandlers = {
      scroll: null,
      touchStart: null,
      touchMove: null,
      touchEnd: null,
    }

    this._setupAutoRefresh()
  }

  // Public methods
  scrollDisable() {
    if (!this.cleanupScrollTrap) {
      root.style.overflow = 'hidden'
      this.cleanupScrollTrap = this._preventScrollOutside()
    }
  }

  scrollEnable() {
    if (this.cleanupScrollTrap) {
      root.style.overflow = ''
      this.cleanupScrollTrap()
      this.cleanupScrollTrap = null
    }
  }

  // Destroys the ScrollHandler instance and cleans up all resources
  destroy() {
    if (this.cleanupScrollTrap) {
      this.cleanupScrollTrap()
      this.cleanupScrollTrap = null
    }

    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }

    this.lastTouchY = null

    this.boundHandlers = {
      scroll: null,
      touchStart: null,
      touchMove: null,
      touchEnd: null,
    }
  }

  _setupAutoRefresh() {
    this.observer = new MutationObserver(() => {
      // Re-apply scroll lock if it was active and DOM changed
      if (this.cleanupScrollTrap) {
        this.cleanupScrollTrap()
        this.cleanupScrollTrap = this._preventScrollOutside()
      }
    })

    const container = document.querySelector(this.containerElQuery) || document.body

    this.observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })
  }

  _preventScrollOutside() {
    this.boundHandlers.scroll = this._handleScroll.bind(this)
    this.boundHandlers.touchStart = this._handleTouchStart.bind(this)
    this.boundHandlers.touchMove = this._handleTouchMove.bind(this)
    this.boundHandlers.touchEnd = this._handleTouchEnd.bind(this)

    document.addEventListener('wheel', this.boundHandlers.scroll, {
      passive: false,
    })
    document.addEventListener('touchstart', this.boundHandlers.touchStart, {
      passive: false,
    })
    document.addEventListener('touchmove', this.boundHandlers.touchMove, {
      passive: false,
    })
    document.addEventListener('touchend', this.boundHandlers.touchEnd, {
      passive: false,
    })

    return () => {
      document.removeEventListener('wheel', this.boundHandlers.scroll)
      document.removeEventListener('touchstart', this.boundHandlers.touchStart)
      document.removeEventListener('touchmove', this.boundHandlers.touchMove)
      document.removeEventListener('touchend', this.boundHandlers.touchEnd)

      this.boundHandlers = {
        scroll: null,
        touchStart: null,
        touchMove: null,
        touchEnd: null,
      }
    }
  }

  // Find the closest scrollable ancestor with .js-scroll-lock, or the .js-scroll-lock element itself
  _getScrollLockContainer(eventTarget) {
    // First, check if we're inside a .js-scroll-lock element
    const scrollLockEl = eventTarget.closest('.js-scroll-lock')
    if (!scrollLockEl) return null

    // Find the actual scrollable element (could be the container itself or a child)
    let el = eventTarget
    while (el && el !== scrollLockEl.parentElement) {
      // Check if this element is scrollable
      if (el.scrollHeight > el.clientHeight) {
        const style = getComputedStyle(el)
        const overflowY = style.overflowY
        if (overflowY === 'auto' || overflowY === 'scroll') {
          return el
        }
      }
      el = el.parentElement
    }

    // If no scrollable child found, return the scroll-lock container itself
    return scrollLockEl
  }

  _handleScroll(e) {
    const el = this._getScrollLockContainer(e.target)

    // If not inside any scroll-lock element, prevent scroll
    if (!el) {
      e.preventDefault()
      return
    }

    const deltaY = e.deltaY
    const atTop = el.scrollTop === 0
    const atBottom = Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) <= 1

    const scrollingUp = deltaY < 0
    const scrollingDown = deltaY > 0

    const shouldPrevent = (scrollingUp && atTop) || (scrollingDown && atBottom)

    if (shouldPrevent) {
      e.preventDefault()
    }
  }

  _handleTouchStart(e) {
    if (e.touches.length !== 1) return
    this.lastTouchY = e.touches[0].clientY
  }

  _handleTouchMove(e) {
    const el = this._getScrollLockContainer(e.target)

    // If not inside any scroll-lock element or no starting touch point, prevent scroll
    if (this.lastTouchY === null || !el) {
      if (e.cancelable) {
        e.preventDefault()
      }
      return
    }

    const currentTouchY = e.touches[0].clientY
    const deltaY = currentTouchY - this.lastTouchY

    const atTop = el.scrollTop === 0
    const atBottom = Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) <= 1

    const scrollingUp = deltaY > 0
    const scrollingDown = deltaY < 0

    const shouldPrevent = (scrollingUp && atTop) || (scrollingDown && atBottom)

    if (shouldPrevent && e.cancelable) {
      e.preventDefault()
    }

    this.lastTouchY = currentTouchY
  }

  _handleTouchEnd() {
    this.lastTouchY = null
  }
}

// event delegation
// example; on('body', 'click', '.accordion-toggle, .accordion-toggle *', e => {…});
const on = (selector, eventType, childSelectors, eventHandler) => {
  const _childSelectors = childSelectors.split(',')
  const elements = document.querySelectorAll(selector)

  for (element of elements) {
    element.addEventListener(eventType, (eventOnElement) => {
      _childSelectors.forEach((selector) => {
        if (eventOnElement.target.matches(selector) || eventOnElement.target.closest(selector)) {
          eventHandler(eventOnElement)
        }
      })
    })
  }
}

const parseHtmlString = (htmlString) => {
  const parser = new DOMParser()
  return parser.parseFromString(htmlString, 'text/html')
}

const setAriaHiddenAttributes = (el, active) => {
  if (!el) return

  el.setAttribute('aria-hidden', !active)
}

// TODO:
// throttle
let timerId
function debounce(func, delay) {
  // Cancels the setTimeout method execution
  clearTimeout(timerId)

  // Executes the func after delay time.
  timerId = setTimeout(func, delay)
}
